import React, { useContext } from "react";
import { GlobalContext } from "../Context/GlobalState";
const GlobalLoader = () => {
  const { transactionLoader } = useContext(GlobalContext);

  if (!transactionLoader) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src="/aiload.gif" alt="Loading..." style={{ width: "100px" }} />
    </div>
  );
};

export default GlobalLoader;
